import { OtpInputField as AntdOtpInputField } from "@empglabs/backoffice-ui-kit"

const OtpInputField = props => {
  return <AntdOtpInputField {...props} />
}

export default OtpInputField
